import { render, staticRenderFns } from "./BrandWrapper.vue?vue&type=template&id=14b72e32&scoped=true"
import script from "./BrandWrapper.vue?vue&type=script&lang=js"
export * from "./BrandWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b72e32",
  null
  
)

export default component.exports